import Main from './components/main/main.html'

new Main({
  target: document.body
})


// WEBPACK FOOTER //
// ./src/index.js